export default __webpack_public_path__ + "static/media/2015-AMcover.30e65303.png";